import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditInputComponent from "../../components/EditInputComponent/EditInputComponent";
import * as React from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  handleErrorState,
  skeletonHandler,
} from "../../HandleSlice/HandleSlice";
import CreateSkeleton from "../../components/CreateSkeleton/CreateSkeleton";
import "react-toastify/dist/ReactToastify.css";
import { INTERNAL_PATHS } from "../../configs/routes.config";
import { Toastify } from "../../utils/function.utils";
import Error from "../../components/Error/Error";
import { ToastContainer } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import ExpertModal from "../../components/ExpertModal/ExpertModal";
import carParts from "../../assets/image/carParts.png";
import { dotsData } from "../../utils/staticData";
import TransactionsCard from "../../components/TransactionsCard/TransactionsCard";
import Orders from "../../components/Orders/Orders";

const DynamicEditPage = () => {
  const [inputData, setInputData] = useState();
  const [editData, setEditData] = useState([]);
  const [errorsValidation, setErrorsValidation] = useState({});
  const [selectSearchData, setSelectSearchData] = useState({});
  const [selectRouteMultipleKeys, setSelectRouteMultipleKeys] = useState({});
  const [
    selectAllSelectSearchMultiplekeys,
    setSelectAllSelectSearchMultiplekeys,
  ] = useState({});
  const [selectDynamicData, setSelectDynamicData] = useState({});
  const [required, setRequired] = useState([]);
  const [expertModalOpen, setExpertModalOpen] = useState(true);
  const location = useParams();
  const data = useSelector((data) => data.hamberger);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pathname = useLocation();
  const params = useParams();
  const dataState = useSelector((state) => state.hamberger);
  function objectMakerHandler() {
    let isRequired = 0;

    required.map((item) => {
      if (inputData[item.key] === "") {
        isRequired = 1;
        Toastify("error", `فیلد ${item.label} وارد نشده`);
      }
    });
    if (isRequired === 0) {
      selectRouteMultipleKeys.map((item) => {
        inputData[item] = inputData[item].map((item2) => {
          return item2.value;
        });
      });
      selectAllSelectSearchMultiplekeys.map((item) => {
        inputData[item] = inputData[item].map((item2) => {
          return item2.value;
        });
      });
      inputData["X-HTTP-Method-Override"] = "PUT";
      const queryParams = localStorage.getItem("queryParams");
      axios
        .put(`/${location.model}/${location.id}`, inputData)
        .then(() => {
          if (searchParams.get("loc") === "url") {
            const prevRoute = localStorage.getItem("prevRoute");
            navigate(`/${prevRoute}${queryParams ? queryParams : ""}`);
            Toastify("success", "اطلاعات با موفقیت ویرایش شد");
          } else {
            navigate(`/${location.model}${queryParams ? queryParams : ""}`);
            Toastify("success", "اطلاعات با موفقیت ویرایش شد");
          }
        })
        .catch((e) => {
          if (e.response.status === 422) {
            setErrorsValidation(e.response.data.errors);
          }
        });
    }
  }

  useEffect(() => {
    dispatch(skeletonHandler(true));
    dispatch(handleErrorState(""));
    axios(`/${location.model}/${location.id}${INTERNAL_PATHS.EDIT}`)
      .then((response) => {
        setEditData(response.data);
        let array1 = response.data.schema.form.filter((item) => {
          if (item.controlType === "select_route_multiple") {
            return item;
          }
        });
        let array2 = array1.map((item) => {
          return item.key;
        });

        let array3 = response.data.schema.form.filter((item) => {
          if (item.controlType === "select_all_select_search_multiple") {
            return item;
          }
        });

        let array4 = array3.map((item) => {
          return item.key;
        });

        setSelectRouteMultipleKeys(array2);
        setSelectAllSelectSearchMultiplekeys(array4);
        dispatch(skeletonHandler(false));
      })
      .then((res2) => {
        console.log(res2);
      })
      .catch((e) => {
        dispatch(skeletonHandler(false));
        console.log(e);
        // if (e.response.status === 422) {
        //   setErrorsValidation(e.response.data.errors);
        // }
      });
  }, [dispatch, location.model, location.id]);

  useEffect(() => {
    if (localStorage.getItem("expertId")) {
      setExpertModalOpen(false);
    } else {
      setExpertModalOpen(true);
    }
  }, [pathname]);

  function cancelMakerHandler() {
    const queryParams = localStorage.getItem("queryParams");
    if (searchParams.get("loc") === "url") {
      const prevRoute = localStorage.getItem("prevRoute");
      navigate(`/${prevRoute}${queryParams ? queryParams : ""}`);
      Toastify("error", "تغییرات ایجاد شده لغو شد");
    } else {
      navigate(`/${location.model}${queryParams ? queryParams : ""}`);
      Toastify("error", "تغییرات ایجاد شده لغو شد");
    }
  }

  const dataStoreClickHandler = () => {
    axios
      .post("/update/detail/expert_information", {
        advertise_id: params?.id,
        expert_id: localStorage.getItem("expertId"),
      })
      .then((res) => {
        Toastify("success", res?.data?.msg);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      {dataState.errorState === 404 || dataState.errorState === 500 ? (
        <Error error={dataState.errorState} />
      ) : (
        ""
      )}
      <div className="bg-body_background w-[calc(100%)] dark:bg-[#152A38] 900:mr-[238px] 900:w-[calc(100%-238px)] pt-[90px] pb-5">
        {(pathname.pathname.startsWith("/visit-expert-detail-seller") ||
          pathname.pathname.startsWith("/visit-expert-detail-buyer") ||
          pathname.pathname.startsWith("/view-attribute-group-expert")) && (
          <div
            className={
              "bg-white w-[80%] m-auto mt-10 rounded-[8px] p-[25px] flex justify-between items-center"
            }
          >
            <div>
              <span>نام کارشناس : </span>
              <span>
                {pathname.pathname.startsWith("/visit-expert-detail-seller/") &&
                  (JSON.parse(localStorage.getItem("expertItem"))?.full_name
                    ? JSON.parse(localStorage.getItem("expertItem"))?.full_name
                    : JSON.parse(localStorage.getItem("expertItem"))?.mobile)}

                {pathname.pathname.startsWith("/visit-expert-detail-buyer/") &&
                  (JSON.parse(localStorage.getItem("expertItem"))?.full_name
                    ? JSON.parse(localStorage.getItem("expertItem"))?.full_name
                    : JSON.parse(localStorage.getItem("expertItem"))?.mobile)}

                {pathname.pathname.startsWith(
                  "/view-attribute-group-expert/",
                ) && editData?.expert_name}

                {pathname.pathname.startsWith(
                  "/view-attribute-group-expert-request/",
                ) && editData?.expert_name}
              </span>
            </div>

            {/*<div onClick={dataStoreClickHandler}>*/}
            {/*  <button*/}
            {/*    className={*/}
            {/*      "ml-5 560:w-[140px] text-center h-[38px] rounded-[3px] bg-confirm_button_background border border-confirm_button_border text-confirm_button_text hover:bg-confirm_button_background_hover"*/}
            {/*    }*/}
            {/*  >*/}
            {/*    <i className="fa fa-check" aria-hidden="true"></i>*/}
            {/*    <span className="inline-block mr-1">ذخیره اطلاعات</span>*/}
            {/*  </button>*/}
            {/*</div>*/}
          </div>
        )}

        <div
          className={`relative bg-component_background shadow-box dark:bg-[#29435C] rounded-[12px] px-[25px] pb-[25px] pt-2 sm:pt-[25px] m-auto mt-2`}
          style={{ width: `80%` }}
        >
          <h2 className="text-[14px] font-extrabold">
            <i className={`${editData.icon}`}></i> {editData.title}
          </h2>
          <div
            className={`${pathname?.pathname.startsWith("/visit-expert-detail-buyer/") || pathname?.pathname.startsWith("/visit-expert-detail-seller/") || pathname?.pathname.startsWith("/view-attribute-group-expert/") || pathname?.pathname.startsWith("/view-attribute-group-expert-request/") ? "grid 780:grid-cols-3 560:grid-cols-2 grid-cols-1 gap-4" : "grid grid-cols-1 560:grid-cols-12 justify-between items-start sm:gap-x-7 sm:gap-y-7"}`}
          >
            {editData.length !== 0
              ? editData?.schema?.form
                ? editData.schema.form.map((item, index) => (
                    <EditInputComponent
                      item={item}
                      editData={editData}
                      key={item.key}
                      inputData={editData.data}
                      setInputData={setInputData}
                      editDataValue={editData.data[item.key]}
                      setEditData={setEditData}
                      index={index}
                      pageType="edit"
                      // editData={editData.data}
                      setSelectDynamicData={setSelectDynamicData}
                      selectDynamicData={selectDynamicData}
                      setSelectSearchData={setSelectSearchData}
                      selectSearchData={selectSearchData}
                      id={`${item.controlType}-${index}`}
                      setRequired={setRequired}
                      required={required}
                    >
                      {errorsValidation[item.key]}
                    </EditInputComponent>
                  ))
                : editData?.data.map((item, index) => (
                    <EditInputComponent
                      key={item.id}
                      item={item}
                      expert={editData?.expert}
                      inputData={editData.data}
                      setInputData={setInputData}
                      pageType="edit"
                    >
                      {errorsValidation[item.key]}
                    </EditInputComponent>
                  ))
              : ""}
            {editData?.data?.damaged_items?.length && (
              <div className="w-full flex flex-col items-center sm:col-span-12 mt-8 mb-4">
                <div className="relative sm:w-[500px] 450:w-[300px] w-[200px] h-auto self-end m-auto">
                  <img src={carParts} alt="نقشه ماشین" />
                  {editData?.data?.damaged_items?.map((item, index) => (
                    <div
                      key={dotsData[item?.toLowerCase()]?.name + index}
                      style={{
                        backgroundColor: dotsData[item?.toLowerCase()]?.color,
                        top: `${dotsData[item?.toLowerCase()]?.top}%`,
                        right: `${dotsData[item?.toLowerCase()]?.right}%`,
                      }}
                      className="450:size-3 size-2 rounded-full absolute z-[2]"
                    ></div>
                  ))}
                </div>
                <div className="flex items-center gap-6">
                  <div className="flex gap-1 items-center">
                    <div className="size-[14px] bg-[#608EF2] rounded-full"></div>
                    <span className="text-xs font-medium text-text-3">
                      اسیب جزئی
                    </span>
                  </div>
                  <div className="flex gap-1 items-center">
                    <div className="size-[14px] bg-[#FFC370] rounded-full"></div>
                    <span className="text-xs font-medium text-text-3">
                      اسیب
                    </span>
                  </div>
                  <div className="flex gap-1 items-center">
                    <div className="size-[14px] bg-[#F66B34] rounded-full"></div>
                    <span className="text-xs font-medium text-text-3">
                      تعویض
                    </span>
                  </div>
                </div>
              </div>
            )}
            {editData?.data?.transactions?.length ? (
              <div className={"mt-8 w-full sm:col-span-12"}>
                <h2 className={"mb-4"}>تراکنش ها</h2>
                <ul className={" flex flex-col gap-2"}>
                  {editData?.data?.transactions?.map((item) => (
                    <TransactionsCard data={item} ke={item?.id} />
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}

            {editData?.data?.orders?.length > 0 && editData?.data?.orders && (
              <div className={"mt-8 w-full sm:col-span-12"}>
                <Orders editData={editData} />
              </div>
            )}

            {data.skeletonState && <CreateSkeleton />}
            <div className="280:flex justify-end col-span-full mt-8 sm:mt-0">
              {!pathname?.pathname.startsWith("/visit-expert-detail-buyer/") &&
              !pathname?.pathname.startsWith("/visit-expert-detail-seller/") ? (
                <div onClick={objectMakerHandler}>
                  <button
                    className={
                      "ml-5 w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] bg-confirm_button_background border border-confirm_button_border text-confirm_button_text hover:bg-confirm_button_background_hover"
                    }
                  >
                    <i className="fa fa-check" aria-hidden="true"></i>
                    <span className="inline-block mr-1">ثبت</span>
                  </button>
                </div>
              ) : (
                <div
                  className={`${editData?.expert?.length === 0 ? "hidden" : "block"}`}
                  onClick={() => {
                    setExpertModalOpen(true);
                    localStorage.removeItem("expertId");
                  }}
                >
                  <button
                    className={
                      "ml-5 560:w-[140px] text-center h-[38px] rounded-[3px] border border-confirm_button_border text-stone-500 "
                    }
                  >
                    <span className="inline-block mr-1">تغییر کارشناس</span>
                  </button>
                </div>
              )}
              <div onClick={cancelMakerHandler}>
                <button
                  className={`${editData?.expert?.length === 0 ? "absolute left-12 bottom-2" : ""} z-[23423432] w-[80px] 560:w-[120px] text-center h-[38px] rounded-[3px] border border-cancel_button_border dark:bg-[#ff8992] dark:text-white dark:hover:bg-[#fd727d] bg-cancel_button_background text-cancel_button_text hover:bg-cancel_button_background_hover mt-5 280:mt-0`}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                  <span className="inline-block mr-1">لغو</span>
                </button>
              </div>
            </div>
          </div>
          {editData?.expert?.length > 0 && expertModalOpen ? (
            <ExpertModal
              editData={editData}
              setExpertModalOpen={setExpertModalOpen}
            />
          ) : expertModalOpen && editData?.expert?.length === 0 ? (
            <div
              className={
                "absolute z-50 w-full h-full top-0 left-0 bg-[#000]/30 rounded-[12px] p-4 flex justify-center items-center text-[40px] text-red-600"
              }
            >
              <span className={"-rotate-45"}> کارشناسی نشده است</span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default DynamicEditPage;
